import { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { DEFAULT_FIXED_HEADER_HEIGHT } from 'Utils/Constants';
import { attachEventListener, removeEventListener, calculateScrollPosition } from 'Utils/Browser';

const SCROLL_THROTTLE_DELAY = 300;
const DEFAULT_SCROLL_CLASS = '';

export default function useScroll({ scrollTo = DEFAULT_FIXED_HEADER_HEIGHT, className = '' }) {
  const [isScrolled, setScrolled] = useState(false);
  const [scrolledClassName, setScrolledClassName] = useState(DEFAULT_SCROLL_CLASS);

  useEffect(() => {
    const throttledScroll = throttle(function handleScroll() {
      const scrollPosition = calculateScrollPosition();
      setScrolled(scrollPosition > scrollTo);
    }, SCROLL_THROTTLE_DELAY);

    attachEventListener('scroll', throttledScroll);
    return () => {
      removeEventListener('scroll', throttledScroll);
    };
  }, [scrollTo, setScrolled]);

  useEffect(() => {
    const scrollClass = isScrolled ? className : DEFAULT_SCROLL_CLASS;
    setScrolledClassName(scrollClass);
  }, [isScrolled, className, setScrolledClassName]);

  return {
    isScrolled,
    scrolledClassName,
  };
}
